import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const PageWrapper = styled(Box)`
  width: 100%;
  overflow-y: auto;
`;

export const PageContent = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 29px;
`;

export const CardsDivider = styled(Box)`
  height: 25px;
`;

export const InsideCardDivider = styled(Box)`
  height: 15px;
`;
